import Navbar from '../../views/navBar';
import Footer from '../../views/footer';

const customerLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default customerLayout;
